import { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { authService } from '../utils/auth'

interface AdminLayoutProps {
  children: ReactNode
}

function AdminLayout({ children }: AdminLayoutProps) {
  const user = authService.getCurrentUser()

  return (
    <div className="min-vh-100 bg-light">
      {/* Admin Header */}
      <header className="bg-white shadow-sm border-bottom">
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid px-4">
            <Link to="/admin" className="navbar-brand fs-5 fw-bold text-dark">
              🔧 Admin Panel
            </Link>
            
            <div className="d-flex align-items-center gap-3">
              <span className="text-muted small">
                Logged in as: <strong>{user?.name}</strong>
              </span>
              <Link to="/" className="btn btn-outline-secondary btn-sm">
                ← Back to Website
              </Link>
              <button 
                onClick={() => authService.logout()}
                className="btn btn-danger btn-sm"
              >
                Sign Out
              </button>
            </div>
          </div>
        </nav>
      </header>

      {/* Main Content */}
      <main className="container-fluid py-4">
        {children}
      </main>

      {/* Admin Footer */}
      <footer className="bg-white border-top mt-5">
        <div className="container-fluid px-4 py-3">
          <div className="row align-items-center">
            <div className="col">
              <small className="text-muted">
                The Salty Mermaid Administration Panel
              </small>
            </div>
            <div className="col-auto">
              <small className="text-muted">
                Version 1.0 | Last updated: 2025-08-25
              </small>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default AdminLayout